import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';

const ChornaPage = () => {
  return <ComingSoon title="Chorna" subtitle="Our Products" />;
};

export const Route = createFileRoute('/$locale/products/chorna')({
  component: ChornaPage,
});
